import { formatCurrency } from "@/components/Layout";

export const FinancialSummary = ({ summary, currency }) => {
  if (!summary) return null;
  
  return (
    <div className="grid grid-cols-3 gap-3 mb-4">
      <div className="text-center p-4 rounded-2xl bg-white border border-p2p-border/50 shadow-sm">
        <p className="text-xs text-p2p-muted font-medium mb-1">Income</p>
        <p className="font-mono text-xl font-bold text-emerald-500">
          {formatCurrency(summary.income, currency)}
        </p>
      </div>
      <div className="text-center p-4 rounded-2xl bg-white border border-p2p-border/50 shadow-sm">
        <p className="text-xs text-p2p-muted font-medium mb-1">Outgoing</p>
        <p className="font-mono text-xl font-bold text-amber-500">
          {formatCurrency(summary.outgoing, currency)}
        </p>
      </div>
      <div className="text-center p-4 rounded-2xl bg-white border border-p2p-border/50 shadow-sm">
        <p className="text-xs text-p2p-muted font-medium mb-1">Left Over</p>
        <p className={`font-mono text-xl font-bold ${
          summary.left_over >= 0 ? 'text-p2p-teal' : 'text-red-500'
        }`}>
          {summary.left_over < 0 && '-'}{formatCurrency(Math.abs(summary.left_over), currency)}
        </p>
      </div>
    </div>
  );
};

export default FinancialSummary;
